import { cn } from "@/lib/utils";

interface ConciergeAvatarProps {
  /** Diameter in pixels. */
  size?: number;
  /** Pulse softly to signal the concierge is active/typing. */
  active?: boolean;
  className?: string;
}

/** The AI concierge's illustrated bellhop avatar, masked to a circle. */
export function ConciergeAvatar({ size = 32, active = false, className }: ConciergeAvatarProps) {
  return (
    <img
      src="/brand/concierge-avatar.png"
      alt="컨시어지"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={cn(
        "shrink-0 rounded-full object-cover ring-1 ring-border/60 shadow-xs",
        active && "animate-breathe",
        className
      )}
    />
  );
}
